<template>
  <div class="application">
    <div class="application__avatar">
      <router-link
        :to="{
          name: 'EventPage',
          params: { link: applicationData.event.link },
        }"
      >
        <el-avatar class="event-table__avatar" :size="50">
          <activity-image :activity="applicationData.event.activityId" />
        </el-avatar>
      </router-link>
    </div>

    <div class="application__content">
      <div class="application__heading">
        <span class="application__title">
          <router-link
            :to="{
              name: 'EventPage',
              params: { link: applicationData.event.link },
            }"
          >
            {{ applicationData.event.name }}
          </router-link>
        </span>

        <span class="application__status">
          <el-tag type="primary">
            {{ applicationData.status }}
          </el-tag>
        </span>
      </div>

      <div class="application__date">
        {{ formatDate(applicationData.event.startDate, SHORT_DATETIME_FORMAT) }}
      </div>
      <div class="application__comments" v-if="applicationData.comments">
        You: {{ applicationData.comments }}
      </div>
      <div class="application__comments" v-if="applicationData.responseComments">
        Organizer: {{ applicationData.responseComments }}
      </div>
    </div>

    <div class="application__action">
      <el-button
        type="danger"
        plain
        @click="requestCancelApplication"
        :disabled="
          isButtonDisabled(
            `cancel-application-${applicationData.applicationId}`,
          )
        "
      >
        Cancel
      </el-button>
    </div>
  </div>
</template>

<script>
import ActivityImage from '@/components/common/ActivityImage.vue';
import { cancelOutgoingApplication } from '@/api/application.js';
import { showMessage } from '@/utils/messages.js';
import { SHORT_DATETIME_FORMAT, formatDate } from '@/utils/index.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'ApplicationPreview',
  props: {
    applicationData: {
      type: Object,
      required: true,
    },
  },
  components: {
    ActivityImage,
  },
  data() {
    return {
      SHORT_DATETIME_FORMAT,
    };
  },
  mixins: [disableButton],
  methods: {
    showMessage,
    formatDate,
    async requestCancelApplication() {
      const { applicationId } = this.applicationData;
      this.disableButton(`cancel-application-${applicationId}`);

      const { success } = await cancelOutgoingApplication({ applicationId });

      this.enableButton(`cancel-application-${applicationId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'The application has been canceled',
        });
        this.$emit('update-data');
      }
    },
  },
};
</script>

<style lang="scss">
.application {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }
  &__content {
    flex-grow: 1;
    margin-right: var(--global-dimension-size-250);
  }
  &__heading {
  }
  &__title {
    font-weight: 500;
  }
  &__status {
    margin-left: var(--global-dimension-size-200);
  }
  &__date {
    margin-bottom: var(--global-dimension-size-125);
    font-size: var(--font-size-200);
  }
  &__comment {
    font-size: var(--font-size-200);
  }
  &__action {
  }
}
</style>
